import { Link } from "@/components/LocalizedLink";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export default function Footer() {
  const { tx } = useLang();
  return (
    <footer className="bg-ink text-slate-400">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link
              to="/"
              data-testid="footer-logo-link"
              className="focus-ring flex w-fit items-center gap-2.5"
            >
              <img
                src="/logo.png"
                alt="GADULABS logo"
                className="h-8 w-8"
              />
              <span className="font-display text-lg font-bold tracking-tight text-white">
                GADULABS
              </span>
            </Link>
            <p className="mt-5 max-w-xs text-sm leading-relaxed">
              {tx(
                "Software products for real business problems.",
                "Gerçek iş problemleri için yazılım ürünleri.",
              )}
            </p>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
              {tx("Portfolio", "Portföy")}
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link
                  to="/products/cernio"
                  data-testid="footer-cernio-link"
                  className="focus-ring transition-colors duration-300 hover:text-white"
                >
                  Cernio
                </Link>
              </li>
              <li><Link to="/projects/dose-modernization" className="focus-ring hover:text-white">DOSE Modernization</Link></li>
              <li><Link to="/projects/kampanyambenim" className="focus-ring hover:text-white">KampanyamBenim</Link></li>
            </ul>
            <h3 className="mt-8 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
              {tx("Legal", "Yasal")}
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link
                  to="/privacy"
                  data-testid="footer-privacy-link"
                  className="focus-ring transition-colors duration-300 hover:text-white"
                >
                  {tx("Privacy Policy", "Gizlilik Politikası")}
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  data-testid="footer-terms-link"
                  className="focus-ring transition-colors duration-300 hover:text-white"
                >
                  {tx("Terms of Use", "Kullanım Koşulları")}
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
              {tx("Company", "Şirket")}
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link
                  to="/company"
                  data-testid="footer-company-link"
                  className="focus-ring transition-colors duration-300 hover:text-white"
                >
                  {tx("About", "Hakkında")}
                </Link>
              </li>
              <li>
                <a
                  href="mailto:info@gadulabs.com"
                  data-testid="footer-mailto-link"
                  className="focus-ring transition-colors duration-300 hover:text-white"
                >
                  {tx("Contact", "İletişim")}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
              {tx("Get in touch", "Bize ulaşın")}
            </h3>
            <a
              href="mailto:info@gadulabs.com"
              data-testid="footer-email-button"
              className="focus-ring group mt-4 inline-flex items-center gap-2 border border-white/15 px-4 py-2.5 text-sm text-slate-200 transition-colors duration-300 hover:border-white/40 hover:text-white"
            >
              info@gadulabs.com
              <ArrowUpRight
                size={14}
                className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
              />
            </a>
            <address className="mt-4 text-xs not-italic leading-relaxed text-slate-500">
              GADULABS YAZILIM LİMİTED ŞİRKETİ
              <br />
              Mustafa Kemal Paşa Mah. Yalova-Bursa Yolu Cad.
              <br />
              A Blok 1. Kademe No: 123/1, İç Kapı No: 10
              <br />
              Merkez / Yalova, Türkiye
            </address>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500">
            © 2026 GADULABS YAZILIM LİMİTED ŞİRKETİ.{" "}
            {tx("All rights reserved.", "Tüm hakları saklıdır.")}
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-600">
            {tx(
              "GADULABS builds and owns its software products.",
              "GADULABS, yazılım ürünlerini kendisi geliştirir ve sahiplenir.",
            )}
          </p>
        </div>
      </div>
    </footer>
  );
}
